export const VEHICLE_PROBLEM = 'vehicleProblem';
export const ABOUT_TO_CLOSE = 'shopAboutToClose';
export const INVALID_PHONE = 'invalidPhone';
export const INVALID_ADDRESS = 'invalidAddress';
export const FAKE_ORDER = 'fakeOrder';
export const CONSUMER_REQUEST = 'consumerRequest';
export const NO_PIN = 'missingPIN';

export default {
  VEHICLE_PROBLEM,
  ABOUT_TO_CLOSE,
  INVALID_PHONE,
  INVALID_ADDRESS,
  FAKE_ORDER,
  CONSUMER_REQUEST,
  NO_PIN,
};



// WEBPACK FOOTER //
// ../ui-components/components/ActionButtons/cancellation-reasons.js